var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 442.72 247.72"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow_toggle_svg__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:40px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_toggle_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arrow_toggle_svg__cls-1",
    d: "M20 20l200.48 207.72L422.72 20.41",
    id: "arrow_toggle_svg__Layer_1-2",
    "data-name": "Layer 1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDIuNzIgMjQ3LjcyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjQwcHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5Bc3NldCA0ODwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjIwIDIwIDIyMC40OCAyMjcuNzIgNDIyLjcyIDIwLjQxIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgArrowToggle as ReactComponent };